module.exports = __webpack_public_path__ + "assets/img/Interwetten.8d9e5d47.png";